var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promote_1218024 1",
    clipPath: "url(#clip0_1409_9849)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 29C35 26.2383 32.7617 24 30 24V34C32.7617 34 35 31.7617 35 29Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35 29C35 26.2383 32.7617 24 30 24V34C32.7617 34 35 31.7617 35 29Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31 33.8987C30.6719 33.969 30.3359 34.0042 30 34.0003V24.0003C30.3359 23.9964 30.6719 24.0315 31 24.1019V33.8987Z",
    fill: "#FFD422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11 36.5703V56C10.9961 57.1016 10.1016 57.9961 9 58H7C5.89844 57.9961 5.00391 57.1016 5 56V35.1719L11 36.5703Z",
    fill: "url(#paint0_linear_1409_9849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58 8C58 12.418 54.418 16 50 16C45.582 16 42 12.418 42 8C42 3.58203 45.582 0 50 0C54.418 0 58 3.58203 58 8Z",
    fill: "url(#paint1_linear_1409_9849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58 50C58 54.418 54.418 58 50 58C45.582 58 42 54.418 42 50C42 45.582 45.582 42 50 42C54.418 42 58 45.582 58 50Z",
    fill: "#78B9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56 23H48C46.8945 23 46 23.8945 46 25V28H50C50 26.8945 50.8945 26 52 26C53.1055 26 54 26.8945 54 28H58V25C58 23.8945 57.1055 23 56 23Z",
    fill: "#FF7956"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M52 30C50.8984 29.9961 50.0039 29.1016 50 28H46V33C46 34.1055 46.8945 35 48 35H56C57.1055 35 58 34.1055 58 33V28H54C53.9961 29.1016 53.1016 29.9961 52 30Z",
    fill: "#FFEB99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M54 28C54 29.1055 53.1055 30 52 30C50.8945 30 50 29.1055 50 28C50 26.8945 50.8945 26 52 26C53.1055 26 54 26.8945 54 28Z",
    fill: "#FFB655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11 21.4414V21.4336L4.63672 22.918C1.92188 23.5508 0 25.9727 0 28.7617V29.2383C0 32.0273 1.92188 34.4492 4.63672 35.082L5 35.168L11 36.5664V21.4414Z",
    fill: "url(#paint2_linear_1409_9849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11 36.5703V37.5703L5 36.1719V35.1719L11 36.5703Z",
    fill: "#57565C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11 21.4336V36.5664L30 41V17L11 21.4336Z",
    fill: "url(#paint3_linear_1409_9849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M31 24.1019V33.8987C30.6719 33.969 30.3359 34.0042 30 34.0003V24.0003C30.3359 23.9964 30.6719 24.0315 31 24.1019Z",
    fill: "#FFD422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M52 10H50V8H52C52.5508 8 53 7.55078 53 7C53 6.44922 52.5508 6 52 6H46V4H52C53.6562 4 55 5.34375 55 7C55 8.65625 53.6562 10 52 10Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M47 7H49V13H47V7Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M51 48H53V46H51C49.3438 46 48 47.3437 48 49H47V51H48V55H50V51H53V49H50C50 48.4492 50.4492 48 51 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M38 28H42V30H38V28Z",
    fill: "url(#paint4_linear_1409_9849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.9453 22.6367L37.7734 19.8086L39.1875 21.2227L36.3594 24.0508L34.9453 22.6367Z",
    fill: "url(#paint5_linear_1409_9849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M34.9453 35.3633L36.3594 33.9492L39.1875 36.7773L37.7734 38.1914L34.9453 35.3633Z",
    fill: "url(#paint6_linear_1409_9849)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1409_9849",
    x1: 8,
    y1: 35.1719,
    x2: 8,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BE00",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1409_9849",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BE00",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1409_9849",
    x1: 5.5,
    y1: 21.4336,
    x2: 5.5,
    y2: 36.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BE00",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1409_9849",
    x1: 20.5,
    y1: 17,
    x2: 20.5,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BE00",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1409_9849",
    x1: 40,
    y1: 28,
    x2: 40,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BE00",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1409_9849",
    x1: 37.0664,
    y1: 19.8086,
    x2: 37.0664,
    y2: 24.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BE00",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1409_9849",
    x1: 37.0664,
    y1: 33.9492,
    x2: 37.0664,
    y2: 38.1914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BE00",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1409_9849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.35214a8d4628da1afd94121974b1f9db.svg";
export { ForwardRef as ReactComponent };